<template>
<vx-card :title="titulo">
    <div class="vx-col  w-full mb-base">
        <form enctype="multipart/form-data">
            <div class="vx-row mb-6">
                <input type="text" v-model="institucion.idinstitucion" hidden>
                <input type="text" v-model="institucion.fecha_create" hidden>
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Nombre</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input type="email" class="w-full" icon-pack="feather" icon-no-border v-model="institucion.nombreInstitucion" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Dirección</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" icon-no-border v-model="institucion.direccion" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Región</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full" id="as1">
                    <form>
                        <vs-radio class="m-2" v-model="institucion.region" vs-value="2">Costa</vs-radio>
                        <vs-radio class="m-2" v-model="institucion.region" vs-value="1">Sierra</vs-radio>
                    </form>

                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Provincia</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <v-select :options="arregloProvincias" :reduce="arregloProvincias => arregloProvincias.id" label="provincia" v-model="institucion.idprovincia"></v-select>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Vendedor</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <v-select :options="arregloAsesores" :reduce="arregloAsesores => arregloAsesores.idusuario" label="nombreUser" v-model="institucion.asesor_id"></v-select>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Estado</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <form>
                        <vs-radio class="m-2" color="success" v-model="institucion.estado" vs-value="1">Activa</vs-radio>
                        <vs-radio class="m-2" color="danger" v-model="institucion.estado" vs-value="0">Inactiva</vs-radio>
                    </form>
                </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full ml-auto">
                <vs-button color="success" type="border" @click="guardar(institucion)" class="m-2">{{ txt_btn }}</vs-button>
                <!-- <vs-button color="danger" type="border" class="m-2" to="/instituciones">Cancelar</vs-button> -->
            </div>
        </form>
    </div>
</vx-card>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import GeneralMixin from '@/mixins/GeneralMixin';
Vue.use(axios)
Vue.component("v-select", vSelect);

export default {
    name: "NuevaInstitucion",
    mixins: [GeneralMixin],
    data() {
        return {
            institucion: {},
            titulo: '',
            idprovincia: "",
            idcanton: "",
            idparroquia: "",
            arregloProvincias: [],
            arregloAsesores: [],
            txt_btn: '',
            idinstitucion: 0,
            msg_notify: '',
        }
    },
    mounted() {
        let me = this;
        me.getProvincia();
        me.getAsesores()
        me.idinstitucion = localStorage.getItem('idinstitucion');
        if (me.idinstitucion > 0) {
            me.titulo = "Editar Institución";
            me.txt_btn = 'Editar'
            me.msg_notify = "actualizada";
            me.getInstitucion(me.idinstitucion);
        } else {
            me.idinstitucion = 0;
            me.titulo = "Nueva Institución";
            me.txt_btn = 'Guardar'
            me.msg_notify = "registrada";
        }
    },
    methods: {
        getProvincia() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'provincias')
                .then(function (response) {
                    me.arregloProvincias = response.data;
                    me.$vs.loading.close();
                })
                .catch(() => {
                    me.$vs.loading.close();
                });
        },

        getAsesores() {
            let me = this;
            me.$http.get(this.$server_url + 'uersXRol/11')
                .then(function (response) {
                    me.arregloAsesores = response.data;
                })
                .catch(() => {})
        },
        getInstitucion(idinstitucion) {
            let me = this;
            // console.log(idinstitucion);
            me.$vs.loading();
            me.$http.get(this.$server_url + 'institucion/' + idinstitucion)
                .then(function (response) {
                    me.institucion = response.data;
                    me.$vs.loading.close();
                })
                .catch(() => {
                    me.$vs.loading.close();
                })
        },
        guardar(data) {
            let me = this;
            console.log(me.institucion)
            if (me.institucion.nombreInstitucion == "" || me.institucion.nombreInstitucion == null) {
                me.f_notificaciones('Ingrese el nombre de la institucion', 'warning');
                return;
            }
            if (me.institucion.direccion == "" || me.institucion.direccion == null) {
                me.f_notificaciones('Ingrese la dirección de la institucion', 'warning');
                return;
            }
            if (me.institucion.region == "" || me.institucion.region == null) {
                me.f_notificaciones('Ingrese la región de la institucion', 'warning');
                return;
            }
            if (me.institucion.idprovincia == "" || me.institucion.idprovincia == null) {
                me.f_notificaciones('Ingrese la provincia de la institucion', 'warning');
                return;
            }
            if (me.institucion.asesor_id == "" || me.institucion.asesor_id == null) {
                me.f_notificaciones('Ingrese el asesor de la institucion', 'warning');
                return;
            }
            me.$vs.loading();
            me.$http.post(this.$server_url + 'institucion', data)
                .then(() => {
                    // me.$router.push('/instituciones');
                    me.f_notificaciones('Institución ' + me.msg_notify + ' correctamente', 'success');
                    me.$emit('changeInstitucion', true)
                    me.$vs.loading.close();
                })
                .catch(() => {
                    me.$vs.loading.close();
                })
        }
    },
}
</script>
